import type { FaireProductEntity } from "../../entity_types/product";

export const p_u527wdh5wy: FaireProductEntity = {
  token: "p_u527wdh5wy",
  type: "product",
  name: "Haribo Bunte Tuete 175g (Germany)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/977fb52b91b8defdd750fbc100158d9b8b3d8a88c28d3ce1370a249157e9a9c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c592734f8e135e3fff1ddedf40647a6d788da305f25fc15a7433661f045d7d22.jpeg",
  ],
  priceDollars: 4,
  description:
    "\nHaribo Bunte Tüte, a vibrant treat from Germany, offers a colorful assortment of classic gummy candies. Each bag is filled with a delightful mix of fruity flavors and fun shapes, providing a burst of joy in every bite. Perfect for sharing or enjoying on your own, these gummies capture the essence of Haribo's tradition of creating delicious and playful confections. Beloved by candy enthusiasts, Haribo Bunte Tüte is a must-try for anyone seeking a cheerful and tasty snack.\n",
  tags: [],
  msrpDollars: 7.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:13.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
